import {gsap} from 'gsap';

const {KitModule, registerModule} = window;

class Statistics extends KitModule {
  constructor($element) {
    super($element);

    this.render = this.render.bind(this);

    this.setVars();
    this.bindEvents();

    if (this.$list.length > 1) {
      this.startTimer();
    }

    this.render();
  }

  setVars() {
    this.activeIndex = 0;
    this.duration = parseInt(this.$element.style.getPropertyValue('--duration')) * 1000;
    this.loopTimer = this.$element.dataset.loopTimer === 'true';
  }

  /**
   * Add appropriate classes to list elements and buttons depending on the
   * current state.
   */
  render() {
    // Lists
    this.$list.forEach(($list, index) => {
      if (index === this.activeIndex) {
        $list.classList.add('is-active');
      } else {
        $list.classList.remove('is-active');
      }
    });

    // Buttons
    this.$button?.forEach(($button, index) => {
      if (index === this.activeIndex) {
        $button.classList.add('is-active');

        if (this.timer) {
          $button.classList.add('show-timer');
        } else {
          $button.classList.remove('show-timer');
        }
      } else {
        $button.classList.remove('is-active', 'show-timer');
      }
    });

    // Animate Numbers
    this.animateNumber(this.$list[this.activeIndex]);
  }

  animateNumber(list, isFromClick) {
    const numbers = list.querySelectorAll('.js-number');
    numbers.forEach(($number) => {
      Statistics.animateValue($number, isFromClick);
    });
  }

  bindEvents() {
    this.$button?.forEach(($button) => {
      $button.addEventListener('click', this);
    });
  }

  /**
   * Start an internal timer that sets `this.activeIndex` automatically —
   * incrementing or resetting to 0 if looping — and then calls render() to
   * update element classes as appropriate.
   */
  startTimer() {
    this.timer = setInterval(() => {
      this.activeIndex++;
      if (this.activeIndex >= this.$button?.length) {
        if (this.loopTimer) {
          this.activeIndex = 0;
        } else {
          this.activeIndex = this.$button?.length - 1;
          this.stopTimer();
          return;
        }
      }

      this.render();
    }, this.duration);
  }

  /**
   * Clear the internal timer and then delete it. (Presence of `this.timer` is
   * used to set the `.show-timer` class on the appropriate button element in
   * render().)
   */
  stopTimer() {
    clearInterval(this.timer);
    delete this.timer;
  }

  /**
   * Disable timer and set the new current index
   * @param {Event} e
   */
  onclick(e) {
    this.stopTimer();

    this.$button?.forEach(($button, index) => {
      if ($button === e.target) {
        this.activeIndex = index;
      }
    });

    this.render();
  }

  static animateValue(element, isFromClick) {
    const target = {val: 0};
    const count = element;
    const finalNumber = count.getAttribute('data-number');

    gsap.to(target, {
      val: finalNumber,
      duration: 2,
      onStart: () => {
        if (isFromClick) {
          count.textContent = '0';
        }
      },
      onUpdate: () => {
        const value = parseFloat(target.val);

        if (finalNumber >= 1000) {
          // Use 'en' formatting to add comma formatting — ex., '1,000'
          count.textContent = parseInt(value.toFixed(0)).toLocaleString('en');
        } else {
          count.textContent = value.toFixed(0);
        }
      },
    });
  }
}

registerModule('Statistics', Statistics);
